import React from "react";
import WithDrawSOT from "./components/WithDrawSOT";

const ClaimSot = () => {
  const renderView = () => {
    return <WithDrawSOT />;
  };
  return <div>{renderView()}</div>;
};
export default ClaimSot;
